import React, { PureComponent } from 'react';
import { DLToggle } from 'appSrc/components/UI';

export default class FormToggle extends PureComponent {
    render() {
        const { input: { value, name, onFocus, onBlur, onChange, onClick }, meta: { error, touched } } = this.props;
        var props = {
            ...this.props,
            checked: !!value,
            name,
            onChange,
            onClick,
            onFocus,
            onBlur,
            error: touched ? error : undefined,
        };

        return (
            <DLToggle { ...props } />
        );
    }
}

FormToggle.defaultProps = {
    className: '',
    style: {},
};
